import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { LandingSvg } from 'assets';
import { animationParams, animationVariants } from 'fragments';


export const FaqSection = ({
    faqs = [],
    label = 'FAQ',
    title = 'Do You Have Questions?',
    description = 'We have answers! Our most frequently asked questions are available to support you.',
    classNameWrapper = '',
}) => {
    const [expanded, setExpanded] = useState(null);

    const handleChange = (id) => {
        const checkId = expanded === id ? null : id;

        if (id) {
            setExpanded(checkId);
        }
    };

    return (
        <div className={`faq-section-wrapper ${classNameWrapper}`}>
            <div className="container">
                <div className="faq-section-box">
                    <p className="faq-section-label">{label}</p>

                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2 className="faq-section-title" {...animationParams} variants={animationVariants.titleVariantMobile}>
                            {title}
                        </motion.h2>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <motion.p className="faq-section-description" {...animationParams} variants={animationVariants.titleVariantMobile}>
                            {description}
                        </motion.p>
                    </div>

                    <div className="faq-accordion-wrapper">
                        {faqs?.map(({ title, description }, i) => (
                            <motion.div key={i} {...animationParams} variants={animationVariants.cardsVariant}>
                                <Accordion
                                    className="faq-accordion-block"
                                    onChange={() => handleChange(i + 1)}
                                    expanded={expanded === i + 1}
                                >
                                    <AccordionSummary
                                        className="faq-accordion-summary"
                                        expandIcon={<LandingSvg.ArrowDownSvg />}
                                        aria-controls="panel-content"
                                        id="panel-header"
                                    >
                                        {title}
                                    </AccordionSummary>

                                    <AccordionDetails>
                                        <p className="faq-accordion-description">{description}</p>
                                    </AccordionDetails>
                                </Accordion>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
